// extracted by mini-css-extract-plugin
export var avatar = "_ls-3";
export var avatarContainer = "_ls-2";
export var avatarSpacer = "_ls-5";
export var avatarSpacerContainer = "_ls-4";
export var avatarStackContainer = "_ls-1";
export var bubble = "_ls-0";
export var remainderBubble = "_ls-6";